export const api = 'https://magazyn.logikon.eu/warehouse.php';
export const upload = 'https://magazyn.logikon.eu/upload.php';
export const host = 'https://magazyn.logikon.eu/';
export const drawerWidth = 240;
export const appMainPath = '/app';
